import styled, { css } from 'styled-components';
import { Typography } from '@mui/material';
import { AccessTime, CheckRounded, HelpOutline } from '@mui/icons-material';

import colors from '../../../../../../styles/colors';

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  margin-top: 10px;
`;

const CellRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  margin-bottom: ${({ $bottomMargin }) => ($bottomMargin ? '10px' : '0')};
`;

const CellCountContainer = styled.div`
  display: flex;
  align-items: center;
  text-decoration: underline dotted;
  text-underline-position: under;
  font-size: 13px;

  &:hover {
    cursor: pointer;
    color: ${colors.shades.secondary1};
  }
`;

const CellCount = styled(Typography)`
  font-size: 15px;
  font-weight: 500;
`;

const CellMetadata = styled(Typography)`
  font-size: 12px;
  text-wrap: wrap;
  color: ${colors.shades.gamma2};

  ${({ $isPriority }) => $isPriority && css`
    color: ${colors.shades.danger3};
  `}
`;

const CellMetadataIcon = styled(HelpOutline)`
  width: 12px;
  height: 12px;
  cursor: help;
  color: ${colors.shades.secondary3};
`;

const ClaimedIcon = styled(CheckRounded)`
  width: 12px;
  height: 12px;
`;

const ActionableTag = styled.span`
  display: inline-flex;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const TableMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 32px;
  color: ${colors.shades.gamma7};
  font-size: 13px;
`;

const OrderingHint = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${colors.shades.gamma10};
`;

const OrderingHintIcon = styled(AccessTime)`
  width: 14px;
  height: 14px;
`;

export {
  Cell,
  CellRow,
  CellCountContainer,
  CellCount,
  CellMetadata,
  CellMetadataIcon,
  ClaimedIcon,
  ActionableTag,
  TableMessage,
  OrderingHint,
  OrderingHintIcon,
};
